module.exports = __webpack_public_path__ + "media/failed_notif_cargo.e6d78afe.wav";